import PropTypes from "prop-types";
import React, { useCallback, useEffect } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "../Common/withRouter";
import { Link, useLocation } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = props => {
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;
      if (parent2) {
        parent2.classList.add("mm-show");
        const parent3 = parent2.parentElement;
        if (parent3) {
          parent3.classList.add("mm-active");
          parent3.childNodes[0].classList.add("mm-active");
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show");
              parent5.childNodes[0].classList.add("mm-active");
            }
          }
        }
      }
      return false;
    }
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El = parent.childNodes && parent.childNodes[1] ? parent.childNodes[1] : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }
        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.remove("mm-show");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active");
            parent3.childNodes[0].classList.remove("mm-active");
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show");
                parent5.childNodes[0].classList.remove("mm-active");
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        activateParentDropdown(items[i]);
        break;
      }
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    new MetisMenu("#side-menu");
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">Administrare</li>

            <li>
              <Link to="/dashboard" className="waves-effect">
                <i className="uil-home-alt"></i>
                <span>Dashboard</span>
              </Link>
            </li>

            <li>
              <Link to="/anunturi" className="waves-effect">
                <i className="uil-megaphone"></i>
                <span>Anunțuri</span>
              </Link>
            </li>

            <li>
              <Link to="/utilizatori" className="waves-effect">
                <i className="uil-users-alt"></i>
                <span>Utilizatori</span>
              </Link>
            </li>

            <li>
              <Link to="/categorii" className="waves-effect">
                <i className="uil-layers"></i>
                <span>Categorii</span>
              </Link>
            </li>


                        <li>
              <Link to="/custom-fields" className="waves-effect">
                <i className="uil-cube"></i>
                <span>Custom Fields</span>
              </Link>
            </li>

            <li className="menu-title">Financiar & Rapoarte</li>

            <li>
              <Link to="/plati" className="waves-effect">
                <i className="uil-bill"></i>
                <span>Plăți</span>
              </Link>
            </li>

            <li>
              <Link to="/pachete-credite" className="waves-effect">
                <i className="uil-ticket"></i>
                <span>Pachete Credite</span>
              </Link>
            </li>

            <li>
              <Link to="/rapoarte" className="waves-effect">
                <i className="uil-chart-growth"></i>
                <span>Rapoarte</span>
              </Link>
            </li>

            <li className="menu-title">Sistem</li>

            <li>
              <Link to="/setari" className="waves-effect">
                <i className="uil-setting"></i>
                <span>Setări</span>
              </Link>
            </li>

            <li>
              <Link to="/logout" className="waves-effect text-danger">
                <i className="uil-sign-out-alt text-danger"></i>
                <span>Logout</span>
              </Link>
            </li>

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
